import { emailTemplateSchema } from "@redotech/redo-model/email-template";
import { SortDirection } from "@redotech/redo-model/tables/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getEmailTemplatesByTeam = {
  name: "getEmailTemplatesByTeam" as const,
  input: z.object({ sortDirection: createEnum(SortDirection).optional() }),
  output: z.object({ data: z.array(emailTemplateSchema) }),
};
